import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'

/** Thin enough to read as an edge, wide enough to hit without aiming. */
const RESIZE_HANDLE_WIDTH_PX = 6

export const DEFAULT_DOCK_WIDTH_PX = 490

export const useStyles = makeStyles()((theme: Theme) => ({
  split: {
    display: 'flex',
    alignItems: 'flex-start',
    minHeight: '100vh',
  },
  main: {
    // Lets the page inside respond to the width the dock leaves it, which a
    // media query cannot see — the viewport never changes when the dock opens.
    containerName: 'labra-chat-main',
    containerType: 'inline-size',
    flex: 1,
    // Without this a flex item refuses to shrink below its content's intrinsic
    // width, and the funding cards are wide.
    minWidth: 0,
    minHeight: '100vh',
    position: 'relative',
  },
  dock: {
    width: DEFAULT_DOCK_WIDTH_PX,
    flexShrink: 0,
    // Sized to the window, not the page: a long page would otherwise stretch
    // the column and push the composer below the fold. Sticky keeps the chat in
    // view while the page scrolls beside it, and is also the containing block
    // for the resize handle, which straddles the panel's left border rather
    // than taking a column of its own.
    position: 'sticky',
    top: 0,
    height: '100vh',
  },
  resizeHandle: {
    position: 'absolute',
    zIndex: 1,
    top: 0,
    bottom: 0,
    left: -RESIZE_HANDLE_WIDTH_PX / 2,
    width: RESIZE_HANDLE_WIDTH_PX,
    cursor: 'col-resize',
    background: 'transparent',
    border: 'none',
    padding: 0,
    // Without this a touch drag scrolls the page instead of moving the handle.
    touchAction: 'none',
    '&:hover::after, &:focus-visible::after': {
      background: theme.palette.textBlueV3.main,
    },
  },
  resizing: {
    '&::after': {
      background: theme.palette.textBlueV3.main,
    },
  },
}))
